import { findPersonById } from './peopleStore';
import { findVendorById } from './vendorsStore';
import { findVillageById, villageMasterSeed } from './villages';

/**
 * Resolve display info for an equipment asset owner (Villager or Vendor).
 * Prefers fields already on the API-mapped asset; falls back to mock stores.
 */
export function resolveAssetOwner(asset, lookups = {}) {
  if (!asset) {
    return {
      ownerType: '—',
      ownerId: '',
      ownerName: '—',
      mobile: '',
      villageName: '',
      villageId: '',
    };
  }

  const villages = lookups.villages || villageMasterSeed;
  const village =
    findVillageById(villages, asset.villageId) ||
    (asset.villageName ? { villageName: asset.villageName, villageId: asset.villageId } : null);

  if (asset.ownerType === 'Member' || asset.source === 'user_equipment') {
    return {
      ownerType: 'Member',
      ownerId: asset.userId != null ? String(asset.userId) : '',
      ownerName: asset.ownerName || asset.peopleName || asset.nameAsPerRc || '—',
      mobile: asset.ownerPhone || '',
      villageName: asset.villageName || village?.villageName || '',
      villageId: village?.villageId || asset.villageId || '',
      ownerPath: null,
    };
  }

  if (asset.ownerType === 'Vendor') {
    const v =
      (lookups.vendors || []).find(
        (row) => row.vendorId === asset.vendorId || row.id === asset.vendorDbId,
      ) || findVendorById(asset.vendorId);
    return {
      ownerType: 'Vendor',
      ownerId: asset.vendorId || '',
      ownerName:
        asset.vendorName ||
        v?.tradeAgencyName ||
        asset.nameAsPerRc ||
        asset.vendorId ||
        '—',
      mobile: v?.mobile || '',
      villageName: village?.villageName || asset.villageName || '',
      villageId: village?.villageId || asset.villageId || '',
      ownerPath: asset.vendorId ? `/admin/equipments/vendors/${asset.vendorId}` : null,
    };
  }

  const p =
    (lookups.people || []).find(
      (row) => row.peopleId === asset.peopleId || row.id === asset.peopleDbId,
    ) || findPersonById(asset.peopleId);

  return {
    ownerType: 'Villager',
    ownerId: asset.peopleId || '',
    ownerName:
      asset.peopleName || p?.fullName || asset.nameAsPerRc || asset.peopleId || '—',
    mobile: p?.mobile || '',
    villageName: village?.villageName || asset.villageName || '',
    villageId: village?.villageId || asset.villageId || '',
    ownerPath: asset.peopleId ? `/admin/equipments/villagers/${asset.peopleId}` : null,
  };
}

export function indentStatusBadge(status) {
  if (status === 'Assigned') return 'verified';
  if (status === 'Released') return 'neutral';
  if (status === 'Cancelled' || status === 'Withdrawn') return 'error';
  if (status === 'Recommended' || status === 'In progress') return 'info';
  return 'pending';
}

export function operationalBadge(status) {
  if (status === 'Deployed') return 'warning';
  return 'verified';
}
